import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { isMessagingAdvisoryAdmin } from '../../utils/adminAccess'

interface MapKitAdminRouteProps {
  children: React.ReactNode
}

export const MapKitAdminRoute: React.FC<MapKitAdminRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return <div className="flex h-screen items-center justify-center">Loading...</div>
  }

  if (!isMessagingAdvisoryAdmin(user)) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

